import * as apiTo from '@/modular-api'
import { cloneDeep, get } from 'lodash'

/* um stands for update methods to avoid name clashing */
export default {
  methods: {
    um_didValueChanged(old, newVal) {
      if (typeof old === 'string' && typeof newVal === 'number') return Number(old) !== Number(newVal)
      return old !== newVal
    },

    um_update(event) {
      if (!this.um_didValueChanged(event.oldValue, event.newValue)) return

      const row = cloneDeep(event.data)
      const column = event.column.colId

      row.start_date = this.um_getDateForPost(row.start_date)
      row.end_date = this.um_getDateForPost(row.end_date)
      if (column === 'price' || column === 'exchange_rate') this.um_checkAndUpdateDependencies(row)
      if (column === 'normalized_price' && row.normalized_price && row.price) {
        row.exchange_rate = (Number(row.normalized_price) / Number(row.price)).toFixed(4)
      }
      this.um_updateOtherPrices(row)
      this.um_setVendorPublisherAndFinancialPeriod(row)

      apiTo
        .MODIFY_SUBSCRIPTION_PERIOD(row.id, row)
        .then(({ data }) => {
          this.refreshData(data.result)
        })
        .catch(() => {
          this.$refs.agGrid.updateRow(row.id, { ...event.data, [column]: event.oldValue })
        })
    },

    um_getDateForPost(fieldValue) {
      const {
        formatDateForPost,
        settings: { date_format }
      } = this
      return formatDateForPost(fieldValue, [date_format, 'YYYY-MM-DD'])
    },

    um_checkAndUpdateDependencies(data) {
      if (data.price && data.exchange_rate) {
        data.normalized_price = (Number(data.price) * Number(data.exchange_rate)).toFixed(2)
        data.price = Number(data.price).toFixed(2)
        data.exchange_rate = Number(data.exchange_rate).toFixed(4)
      }
    },

    um_updateOtherPrices(data) {
      data.list_price = this.um_getFixedValue(data.list_price)
      data.first_offer_price = this.um_getFixedValue(data.first_offer_price)
      data.price = this.um_getFixedValue(data.price)
      data.forecasted_price = this.um_getFixedValue(data.forecasted_price)
      data.exchange_rate = this.um_getFixedValue(data.exchange_rate, 4)
      data.normalized_price = this.um_getFixedValue(data.normalized_price)
    },

    um_getFixedValue(field, digit = 2) {
      return field !== null ? Number(field).toFixed(digit) : null
    },

    um_setVendorPublisherAndFinancialPeriod(data) {
      data.vendor_id = get(data, 'vendor.id')
      data.publisher_id = get(data, 'publisher.id')
      data.financial_period_id = get(data, 'financial_period.id')
      delete data.vendor
      delete data.publisher
      delete data.financial_period
    }
  }
}
